import Footer from "../Components/Footer";
import Header from "../Components/Header";
import WikiComp from "../Components/WikiComp/WikiComp";

function WikiPage()
{
    return(
        <div>
            <Header/>
            <WikiComp/>
            <Footer/>
        </div>
    );
} 

export default WikiPage;